<template>
    Das hat leider nicht funktioniert.<br />
    Bitte kontaktiere <a :href="`mailto:${email.service}`">{{ email.service }}</a> und schildere dein Problem.<br />
    Vielen Dank
</template>

<script setup lang="ts">
import { email } from '@/lib/contact';
</script>
